import React from 'react'
import "../styles/Workers.css"
import Mfooter from '../Components/Mfooter';
import Hnav from '../Components/Hnav';

const Workers = () => {
    return (
        <>
            <Hnav></Hnav>
            <section id='sectionnnn'>
                <div className="containerrrr">
                    <div className='lol'>
                        <h3>MEET THE TEAM</h3>
                    </div>
                    <div className="card-wrapperrrr">
                        <div className="cardddd">
                            <img src="hoh.jpg" alt="card background" className="card-image" />
                            <img src="bmale.jpg" alt="pro image" className="pro-image" />
                            <h1>Dr.Jake Affum</h1>
                            <p className="job.tittle">Doctor</p>
                            <p className="about">
                                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                Deserunt veritatis ducimus
                            </p>
                        </div>
                        <div className="cardddd">
                            <img src="hoh.jpg" alt="card background" className="card-image" />
                            <img src="bmale.jpg" alt="pro image" className="pro-image" />
                            <h1>Dr.Jake Affum</h1>
                            <p className="job.tittle">Doctor</p>
                            <p className="about">
                                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                Deserunt veritatis ducimus
                            </p>
                            
                        </div>
                        <div className="cardddd">
                            <img src="hoh.jpg" alt="card background" className="card-image" />
                            <img src="bmale.jpg" alt="pro image" className="pro-image" />
                            <h1>Dr.Jake Affum</h1>
                            <p className="job.tittle">Doctor</p>
                            <p className="about">
                                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                Deserunt veritatis ducimus
                            </p>
                          
                        </div>
                        <div className="cardddd">
                            <img src="hoh.jpg" alt="card background" className="card-image" />
                            <img src="bmale.jpg" alt="pro image" className="pro-image" />
                            <h1>Dr.Jake Affum</h1>
                            <p className="job.tittle">Doctor</p>
                            <p className="about">
                                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                Deserunt veritatis ducimus
                            </p>
                            
                        </div>
                        <div className="cardddd">
                            <img src="hoh.jpg" alt="card background" className="card-image" />
                            <img src="bmale.jpg" alt="pro image" className="pro-image" />
                            <h1>Dr.Jake Affum</h1>
                            <p className="job.tittle">Doctor</p>
                            <p className="about">
                                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                Deserunt veritatis ducimus
                            </p>
                            
                        </div>
                        <div className="cardddd">
                            <img src="hoh.jpg" alt="card background" className="card-image" />
                            <img src="bmale.jpg" alt="pro image" className="pro-image" />
                            <h1>Dr.Jake Affum</h1>
                            <p className="job.tittle">Doctor</p>
                            <p className="about">
                                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                Deserunt veritatis ducimus
                            </p>
                            
                        </div>
                        <div className="cardddd">
                            <img src="hoh.jpg" alt="card background" className="card-image" />
                            <img src="bmale.jpg" alt="pro image" className="pro-image" />
                            <h1>Dr.Jake Affum</h1>
                            <p className="job.tittle">Doctor</p>
                            <p className="about">
                                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                Deserunt veritatis ducimus
                            </p>
                            
                        </div>
                        <div className="cardddd">
                            <img src="hoh.jpg" alt="card background" className="card-image" />
                            <img src="bmale.jpg" alt="pro image" className="pro-image" />
                            <h1>Dr.Jake Affum</h1>
                            <p className="job.tittle">Doctor</p>
                            <p className="about">
                                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                Deserunt veritatis ducimus
                            </p>
                            
                        </div>
                        <div className="cardddd">
                            <img src="hoh.jpg" alt="card background" className="card-image" />
                            <img src="bmale.jpg" alt="pro image" className="pro-image" />
                            <h1>Dr.Jake Affum</h1>
                            <p className="job.tittle">Doctor</p>
                            <p className="about">
                                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                Deserunt veritatis ducimus
                            </p>
                           
                        </div>
                        <div className="cardddd">
                            <img src="hoh.jpg" alt="card background" className="card-image" />
                            <img src="bmale.jpg" alt="pro image" className="pro-image" />
                            <h1>Dr.Jake Affum</h1>
                            <p className="job.tittle">Doctor</p>
                            <p className="about">
                                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                Deserunt veritatis ducimus
                            </p>
                           
                        </div>
                        <div className="cardddd">
                            <img src="hoh.jpg" alt="card background" className="card-image" />
                            <img src="bmale.jpg" alt="pro image" className="pro-image" />
                            <h1>Dr.Jake Affum</h1>
                            <p className="job.tittle">Doctor</p>
                            <p className="about">
                                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                Deserunt veritatis ducimus
                            </p>

                        </div>
                        <div className="cardddd">
                            <img src="hoh.jpg" alt="card background" className="card-image" />
                            <img src="bmale.jpg" alt="pro image" className="pro-image" />
                            <h1>Dr.Jake Affum</h1>
                            <p className="job.tittle">Doctor</p>
                            <p className="about">
                                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                Deserunt veritatis ducimus
                            </p>

                        </div>
                    </div>
                </div>
            </section>
            <Mfooter></Mfooter>
        </>
    )
}

export default Workers;